import * as React from 'react';
import Tabs from './../navigation/tabs';

const HomeScreen = ({navigation}) => {
  return (
    <Tabs />
  )
}

export default HomeScreen
